/* Destin product page — customization + pricing + form sync */
(function () {
  'use strict';

  var BASE_PRICES = {
    '2|solitaire': 4667.34, '2|halfPave': 4747.34,
    '3|solitaire': 5767.34, '3|halfPave': 5937.34,
    '4|solitaire': 6367.34, '4|halfPave': 6537.34
  };

  var state = {
    carat: '3', band: 'solitaire',
    prong:     { value: 'claw',  label: 'Claw Prong',      price: 0 },
    peekaboo:  { value: 'none',  label: 'None',           price: 0 },
    gallery:   [{ value: 'plain', label: 'Gold Gallery Rail', price: 0 }],
    engrave:   { value: 'no',    label: 'None',           price: 0, text: '' }
  };

  function money(n) {
    return '$' + n.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  }

  function recompute() {
    var base = BASE_PRICES[state.carat + '|' + state.band];
    var galleryTotal = 0;
    state.gallery.forEach(function(g) { galleryTotal += g.price; });
    var adds = state.prong.price + state.peekaboo.price + galleryTotal + state.engrave.price;
    var total = base + adds;

    document.getElementById('dp-price-display').textContent = money(total);
    document.getElementById('dp-cta-price').textContent = money(total);
    document.getElementById('dp-carat-value').textContent = state.carat + ' carat';
    document.getElementById('dp-band-value').textContent = state.band === 'solitaire' ? 'Polished Gold' : '1/2 Pavé';

    var rows = [
      { label: 'Prong style',        val: state.prong },
      { label: 'Birthstone',         val: state.peekaboo },
      { label: 'Engraving',          val: state.engrave }
    ];
    var html = '';
    rows.forEach(function (r) {
      var cls = r.val.price === 0 ? 'hp-rollup-add included' : 'hp-rollup-add';
      var txt = r.val.price === 0 ? r.val.label + ' (included)' : r.val.label + ' · +' + money(r.val.price);
      html += '<li><span>' + r.label + '</span><span class="' + cls + '">' + txt + '</span></li>';
    });

    // Gallery (multi-select)
    var galleryLabels = state.gallery.map(function(g) {
      return g.price === 0 ? g.label + ' (included)' : g.label + ' · +' + money(g.price);
    });
    var galleryCls = galleryTotal === 0 ? 'hp-rollup-add included' : 'hp-rollup-add';
    html += '<li><span>Gallery & setting details</span><span class="' + galleryCls + '">' + galleryLabels.join(', ') + '</span></li>';

    document.getElementById('dp-rollup').innerHTML = html;

    document.querySelectorAll('.dp-cgroup-current').forEach(function (el) {
      var g = el.dataset.group;
      if (g === 'gallery') {
        el.textContent = state.gallery.map(function(i) { return i.label; }).join(', ');
      } else if (state[g]) {
        el.textContent = state[g].label;
      }
    });

    // Sync hidden form properties
    syncFormProperties(total);
  }

  function syncFormProperties(total) {
    var fields = {
      'dp-prop-price': money(total),
      'dp-prop-stone': state.carat + ' ct Radiant, D Color, VVS2 Lab-Grown',
      'dp-prop-band': state.band === 'solitaire' ? 'Polished Gold' : '1/2 Pavé',
      'dp-prop-prong': state.prong.label,
      'dp-prop-peekaboo': state.peekaboo.label + (state.peekaboo.price > 0 ? ' (+' + money(state.peekaboo.price) + ')' : ''),
      'dp-prop-engrave': state.engrave.text ? '"' + state.engrave.text + '" (+' + money(state.engrave.price) + ')' : 'None',
      'dp-prop-gallery': state.gallery.map(function(g) { return g.label + (g.price > 0 ? ' (+' + money(g.price) + ')' : ''); }).join(', ')
    };
    for (var id in fields) {
      var el = document.getElementById(id);
      if (el) el.value = fields[id];
    }
  }

  /* ── Image swap by carat + band ── */
  function swapGalleryImage() {
    var slides = document.querySelectorAll('.hp-main-image .hp-slide');
    var thumbs = document.querySelectorAll('.hp-thumb');
    var match = document.querySelector('.hp-main-image .hp-slide[data-carat="' + state.carat + '"][data-band="' + state.band + '"]');
    if (!match) match = document.querySelector('.hp-main-image .hp-slide[data-carat="' + state.carat + '"]');
    if (match) {
      slides.forEach(function (s) { s.classList.remove('active'); });
      thumbs.forEach(function (t) { t.classList.remove('active'); });
      match.classList.add('active');
      var matchThumb = document.querySelector('.hp-thumb[data-slide="' + match.dataset.slide + '"]');
      if (matchThumb) matchThumb.classList.add('active');
    }
  }

  /* ── Variant buttons (carat + band) ── */
  document.querySelectorAll('.hp-variant').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var carat = btn.dataset.carat, band = btn.dataset.band;
      if (carat) {
        state.carat = carat;
        document.querySelectorAll('.hp-variant[data-carat]').forEach(function (b) {
          b.setAttribute('aria-checked', b === btn ? 'true' : 'false');
        });
      }
      if (band) {
        state.band = band;
        document.querySelectorAll('.hp-variant[data-band]').forEach(function (b) {
          b.setAttribute('aria-checked', b === btn ? 'true' : 'false');
        });
      }
      if (carat || band) swapGalleryImage();
      recompute();
    });
  });

  /* ── Thumb click handler ── */
  document.querySelectorAll('.hp-thumb').forEach(function (t) {
    t.addEventListener('click', function () {
      document.querySelectorAll('.hp-thumb').forEach(function (x) { x.classList.remove('active'); });
      document.querySelectorAll('.hp-main-image .hp-slide').forEach(function (s) { s.classList.remove('active'); });
      t.classList.add('active');
      var target = document.querySelector('.hp-main-image .hp-slide[data-slide="' + t.dataset.slide + '"]');
      if (target) target.classList.add('active');
    });
  });

  /* ── Customization card clicks (prong, peekaboo, gallery) ── */
  document.querySelectorAll('.dp-grid, .dp-engraving-row, .dp-birthstone-grid').forEach(function (grid) {
    var group = grid.dataset.group;
    if (!group) return;
    grid.querySelectorAll('.dp-card, .dp-swatch').forEach(function (card) {
      card.addEventListener('click', function () {
        if (group === 'gallery') {
          var val = card.dataset.value;
          if (val === 'plain') return;
          var isChecked = card.getAttribute('aria-checked') === 'true';
          card.setAttribute('aria-checked', isChecked ? 'false' : 'true');
          state.gallery = [];
          grid.querySelectorAll('.dp-card[aria-checked="true"]').forEach(function (c) {
            state.gallery.push({
              value: c.dataset.value,
              label: c.dataset.label,
              price: parseFloat(c.dataset.price) || 0
            });
          });
          recompute();
          return;
        }
        grid.querySelectorAll('.dp-card, .dp-swatch').forEach(function (c) {
          c.setAttribute('aria-checked', c === card ? 'true' : 'false');
        });
        state[group] = {
          value: card.dataset.value,
          label: card.dataset.label,
          price: parseFloat(card.dataset.price) || 0
        };
        if (group === 'engrave') {
          var wrap = document.getElementById('dp-engrave-wrap');
          if (card.dataset.value === 'yes') {
            wrap.classList.add('active');
          } else {
            wrap.classList.remove('active');
            state.engrave.text = '';
            document.getElementById('dp-engrave-text').value = '';
            document.getElementById('dp-engrave-count').textContent = '0';
          }
        }
        recompute();
      });
    });
  });

  /* ── Birthstone toggle ── */
  var birthstoneToggle = document.getElementById('dp-birthstone-toggle');
  var birthstoneGrid = document.getElementById('dp-birthstone-grid');
  if (birthstoneToggle && birthstoneGrid) {
    birthstoneToggle.addEventListener('change', function () {
      if (birthstoneToggle.checked) {
        birthstoneGrid.style.display = '';
      } else {
        birthstoneGrid.style.display = 'none';
        birthstoneGrid.querySelectorAll('.dp-swatch').forEach(function (s) {
          s.setAttribute('aria-checked', 'false');
        });
        state.peekaboo = { value: 'none', label: 'None', price: 0 };
        recompute();
      }
    });
  }

  /* ── Engraving input ── */
  var engraveText = document.getElementById('dp-engrave-text');
  var engraveCount = document.getElementById('dp-engrave-count');
  if (engraveText) {
    engraveText.addEventListener('input', function () {
      engraveCount.textContent = engraveText.value.length;
      state.engrave.text = engraveText.value;
      if (engraveText.value.length > 0) {
        state.engrave = { value: 'yes', label: 'Custom Engraving', price: 60, text: engraveText.value };
      } else {
        state.engrave = { value: 'no', label: 'None', price: 0, text: '' };
      }
      recompute();
    });
  }

  /* ── Smooth scroll to customize ── */
  document.querySelectorAll('a[href="#customize"]').forEach(function (a) {
    a.addEventListener('click', function (e) {
      e.preventDefault();
      document.getElementById('customize').scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  });

  recompute();
})();
